export const UID: { [key: string]: string } = {
    VerificationSOPClass: '1.2.840.10008.1.1',
    ImplicitVRLittleEndian: '1.2.840.10008.1.2',
    ExplicitVRLittleEndian: '1.2.840.10008.1.2.1',
    DeflatedExplicitVRLittleEndian: '1.2.840.10008.1.2.1.99',
    ExplicitVRBigEndianRetired: '1.2.840.10008.1.2.2', // retired
    JPEGBaselineProcess1: '1.2.840.10008.1.2.4.50',
    JPEGExtendedProcess24: '1.2.840.10008.1.2.4.51',
    JPEGExtendedProcess35Retired: '1.2.840.10008.1.2.4.52', // retired
    JPEGSpectralSelectionNonHierarchicalProcess68Retired: '1.2.840.10008.1.2.4.53', // retired
    JPEGSpectralSelectionNonHierarchicalProcess79Retired: '1.2.840.10008.1.2.4.54', // retired
    JPEGFullProgressionNonHierarchicalProcess1012Retired: '1.2.840.10008.1.2.4.55', // retired
    JPEGFullProgressionNonHierarchicalProcess1113Retired: '1.2.840.10008.1.2.4.56', // retired
    JPEGLosslessNonHierarchicalProcess14: '1.2.840.10008.1.2.4.57',
    JPEGLosslessNonHierarchicalProcess15Retired: '1.2.840.10008.1.2.4.58', // retired
    JPEGExtendedHierarchicalProcess1618Retired: '1.2.840.10008.1.2.4.59', // retired
    JPEGExtendedHierarchicalProcess1719Retired: '1.2.840.10008.1.2.4.60', // retired
    JPEGSpectralSelectionHierarchicalProcess2022Retired: '1.2.840.10008.1.2.4.61', // retired
    JPEGSpectralSelectionHierarchicalProcess2123Retired: '1.2.840.10008.1.2.4.62', // retired
    JPEGFullProgressionHierarchicalProcess2426Retired: '1.2.840.10008.1.2.4.63', // retired
    JPEGFullProgressionHierarchicalProcess2527Retired: '1.2.840.10008.1.2.4.64', // retired
    JPEGLosslessHierarchicalProcess28Retired: '1.2.840.10008.1.2.4.65', // retired
    JPEGLosslessHierarchicalProcess29Retired: '1.2.840.10008.1.2.4.66', // retired
    JPEGLosslessNonHierarchicalFirstOrderPredictionProcess14SelectionValue1: '1.2.840.10008.1.2.4.70',
    JPEGLSLosslessImageCompression: '1.2.840.10008.1.2.4.80',
    JPEGLSLossyNearLosslessImageCompression: '1.2.840.10008.1.2.4.81',
    JPEG2000ImageCompressionLosslessOnly: '1.2.840.10008.1.2.4.90',
    JPEG2000ImageCompression: '1.2.840.10008.1.2.4.91',
    JPEG2000Part2MulticomponentImageCompressionLosslessOnly: '1.2.840.10008.1.2.4.92',
    JPEG2000Part2MulticomponentImageCompression: '1.2.840.10008.1.2.4.93',
    JPIPReferenced: '1.2.840.10008.1.2.4.94',
    JPIPReferencedDeflate: '1.2.840.10008.1.2.4.95',
    MPEG2MainProfileMainLevel: '1.2.840.10008.1.2.4.100',
    MPEG2MainProfileHighLevel: '1.2.840.10008.1.2.4.101',
    MPEG4AVCH264HighProfileLevel41: '1.2.840.10008.1.2.4.102',
    MPEG4AVCH264BDcompatibleHighProfileLevel41: '1.2.840.10008.1.2.4.103',
    MPEG4AVCH264HighProfileLevel42For2DVideo: '1.2.840.10008.1.2.4.104',
    MPEG4AVCH264HighProfileLevel42For3DVideo: '1.2.840.10008.1.2.4.105',
    MPEG4AVCH264StereoHighProfileLevel42: '1.2.840.10008.1.2.4.106',
    HEVCH265MainProfileLevel51: '1.2.840.10008.1.2.4.107',
    HEVCH265Main10ProfileLevel51: '1.2.840.10008.1.2.4.108',
    RLELossless: '1.2.840.10008.1.2.5',
    RFC2557MIMEencapsulation: '1.2.840.10008.1.2.6.1',
    XMLEncoding: '1.2.840.10008.1.2.6.2',
    MediaStorageDirectoryStorage: '1.2.840.10008.1.3.10',
    TalairachBrainAtlasFrameofReference: '1.2.840.10008.1.4.1.1',
    SPM2T1FrameofReference: '1.2.840.10008.1.4.1.2',
    SPM2T2FrameofReference: '1.2.840.10008.1.4.1.3',
    SPM2PDFrameofReference: '1.2.840.10008.1.4.1.4',
    SPM2EPIFrameofReference: '1.2.840.10008.1.4.1.5',
    SPM2FILT1FrameofReference: '1.2.840.10008.1.4.1.6',
    SPM2PETFrameofReference: '1.2.840.10008.1.4.1.7',
    SPM2TRANSMFrameofReference: '1.2.840.10008.1.4.1.8',
    SPM2SPECTFrameofReference: '1.2.840.10008.1.4.1.9',
    SPM2GRAYFrameofReference: '1.2.840.10008.1.4.1.10',
    SPM2WHITEFrameofReference: '1.2.840.10008.1.4.1.11',
    SPM2CSFFrameofReference: '1.2.840.10008.1.4.1.12',
    SPM2BRAINMASKFrameofReference: '1.2.840.10008.1.4.1.13',
    SPM2AVG305T1FrameofReference: '1.2.840.10008.1.4.1.14',
    SPM2AVG152T1FrameofReference: '1.2.840.10008.1.4.1.15',
    SPM2AVG152T2FrameofReference: '1.2.840.10008.1.4.1.16',
    SPM2AVG152PDFrameofReference: '1.2.840.10008.1.4.1.17',
    SPM2SINGLESUBJT1FrameofReference: '1.2.840.10008.1.4.1.18',
    ICBM452T1FrameofReference: '1.2.840.10008.1.4.2.1',
    ICBMSingleSubjectMRIFrameofReference: '1.2.840.10008.1.4.2.2',
    HotIronColorPaletteSOPInstance: '1.2.840.10008.1.5.1',
    PETColorPaletteSOPInstance: '1.2.840.10008.1.5.2',
    HotMetalBlueColorPaletteSOPInstance: '1.2.840.10008.1.5.3',
    PET20StepColorPaletteSOPInstance: '1.2.840.10008.1.5.4',
    SpringColorPaletteSOPInstance: '1.2.840.10008.1.5.5',
    SummerColorPaletteSOPInstance: '1.2.840.10008.1.5.6',
    FallColorPaletteSOPInstance: '1.2.840.10008.1.5.7',
    WinterColorPaletteSOPInstance: '1.2.840.10008.1.5.8',
    BasicStudyContentNotificationSOPClassRetired: '1.2.840.10008.1.9', // retired
    Papyrus3ImplicitVRLittleEndianRetired: '1.2.840.10008.1.20', // retired
    StorageCommitmentPushModelSOPClass: '1.2.840.10008.1.20.1',
    StorageCommitmentPushModelSOPInstance: '1.2.840.10008.1.20.1.1',
    StorageCommitmentPullModelSOPClassRetired: '1.2.840.10008.1.20.2', // retired
    StorageCommitmentPullModelSOPInstanceRetired: '1.2.840.10008.1.20.2.1', // retired
    ProceduralEventLoggingSOPClass: '1.2.840.10008.1.40',
    ProceduralEventLoggingSOPInstance: '1.2.840.10008.1.40.1',
    SubstanceAdministrationLoggingSOPClass: '1.2.840.10008.1.42',
    SubstanceAdministrationLoggingSOPInstance: '1.2.840.10008.1.42.1',
    DICOMUIDRegistry: '1.2.840.10008.2.6.1',
    DICOMControlledTerminology: '1.2.840.10008.2.16.4',
    AdultMouseAnatomyOntology: '1.2.840.10008.2.16.5',
    UberonOntology: '1.2.840.10008.2.16.6',
    IntegratedTaxonomicInformationSystemITISTaxonomicSerialNumberTSN: '1.2.840.10008.2.16.7',
    MouseGenomeInitiativeMGI: '1.2.840.10008.2.16.8',
    PubChemCompoundCID: '1.2.840.10008.2.16.9',
    DICOMApplicationContextName: '1.2.840.10008.3.1.1.1',
    DetachedPatientManagementSOPClassRetired: '1.2.840.10008.3.1.2.1.1', // retired
    DetachedPatientManagementMetaSOPClassRetired: '1.2.840.10008.3.1.2.1.4', // retired
    DetachedVisitManagementSOPClassRetired: '1.2.840.10008.3.1.2.2.1', // retired
    DetachedStudyManagementSOPClassRetired: '1.2.840.10008.3.1.2.3.1', // retired
    StudyComponentManagementSOPClassRetired: '1.2.840.10008.3.1.2.3.2', // retired
    ModalityPerformedProcedureStepSOPClass: '1.2.840.10008.3.1.2.3.3',
    ModalityPerformedProcedureStepRetrieveSOPClass: '1.2.840.10008.3.1.2.3.4',
    ModalityPerformedProcedureStepNotificationSOPClass: '1.2.840.10008.3.1.2.3.5',
    DetachedResultsManagementSOPClassRetired: '1.2.840.10008.3.1.2.5.1', // retired
    DetachedResultsManagementMetaSOPClassRetired: '1.2.840.10008.3.1.2.5.4', // retired
    DetachedStudyManagementMetaSOPClassRetired: '1.2.840.10008.3.1.2.5.5', // retired
    DetachedInterpretationManagementSOPClassRetired: '1.2.840.10008.3.1.2.6.1', // retired
    StorageServiceClass: '1.2.840.10008.4.2',
    BasicFilmSessionSOPClass: '1.2.840.10008.5.1.1.1',
    BasicFilmBoxSOPClass: '1.2.840.10008.5.1.1.2',
    BasicGrayscaleImageBoxSOPClass: '1.2.840.10008.5.1.1.4',
    BasicColorImageBoxSOPClass: '1.2.840.10008.5.1.1.4.1',
    ReferencedImageBoxSOPClassRetired: '1.2.840.10008.5.1.1.4.2', // retired
    BasicGrayscalePrintManagementMetaSOPClass: '1.2.840.10008.5.1.1.9',
    ReferencedGrayscalePrintManagementMetaSOPClassRetired: '1.2.840.10008.5.1.1.9.1', // retired
    PrintJobSOPClass: '1.2.840.10008.5.1.1.14',
    BasicAnnotationBoxSOPClass: '1.2.840.10008.5.1.1.15',
    PrinterSOPClass: '1.2.840.10008.5.1.1.16',
    PrinterConfigurationRetrievalSOPClass: '1.2.840.10008.5.1.1.16.376',
    PrinterSOPInstance: '1.2.840.10008.5.1.1.17',
    PrinterConfigurationRetrievalSOPInstance: '1.2.840.10008.5.1.1.17.376',
    BasicColorPrintManagementMetaSOPClass: '1.2.840.10008.5.1.1.18',
    ReferencedColorPrintManagementMetaSOPClassRetired: '1.2.840.10008.5.1.1.18.1', // retired
    VOILUTBoxSOPClass: '1.2.840.10008.5.1.1.22',
    PresentationLUTSOPClass: '1.2.840.10008.5.1.1.23',
    ImageOverlayBoxSOPClassRetired: '1.2.840.10008.5.1.1.24', // retired
    BasicPrintImageOverlayBoxSOPClassRetired: '1.2.840.10008.5.1.1.24.1', // retired
    PrintQueueSOPInstanceRetired: '1.2.840.10008.5.1.1.25', // retired
    PrintQueueManagementSOPClassRetired: '1.2.840.10008.5.1.1.26', // retired
    StoredPrintStorageSOPClassRetired: '1.2.840.10008.5.1.1.27', // retired
    HardcopyGrayscaleImageStorageSOPClassRetired: '1.2.840.10008.5.1.1.29', // retired
    HardcopyColorImageStorageSOPClassRetired: '1.2.840.10008.5.1.1.30', // retired
    PullPrintRequestSOPClassRetired: '1.2.840.10008.5.1.1.31', // retired
    PullStoredPrintManagementMetaSOPClassRetired: '1.2.840.10008.5.1.1.32', // retired
    MediaCreationManagementSOPClassUID: '1.2.840.10008.5.1.1.33',
    DisplaySystemSOPClass: '1.2.840.10008.5.1.1.40',
    DisplaySystemSOPInstance: '1.2.840.10008.5.1.1.40.1',
    ComputedRadiographyImageStorage: '1.2.840.10008.5.1.4.1.1.1',
    DigitalXRayImageStorageForPresentation: '1.2.840.10008.5.1.4.1.1.1.1',
    DigitalXRayImageStorageForProcessing: '1.2.840.10008.5.1.4.1.1.1.1.1',
    DigitalMammographyXRayImageStorageForPresentation: '1.2.840.10008.5.1.4.1.1.1.2',
    DigitalMammographyXRayImageStorageForProcessing: '1.2.840.10008.5.1.4.1.1.1.2.1',
    DigitalIntraOralXRayImageStorageForPresentation: '1.2.840.10008.5.1.4.1.1.1.3',
    DigitalIntraOralXRayImageStorageForProcessing: '1.2.840.10008.5.1.4.1.1.1.3.1',
    CTImageStorage: '1.2.840.10008.5.1.4.1.1.2',
    EnhancedCTImageStorage: '1.2.840.10008.5.1.4.1.1.2.1',
    LegacyConvertedEnhancedCTImageStorage: '1.2.840.10008.5.1.4.1.1.2.2',
    UltrasoundMultiframeImageStorageRetired: '1.2.840.10008.5.1.4.1.1.3', // retired
    UltrasoundMultiframeImageStorage: '1.2.840.10008.5.1.4.1.1.3.1',
    MRImageStorage: '1.2.840.10008.5.1.4.1.1.4',
    EnhancedMRImageStorage: '1.2.840.10008.5.1.4.1.1.4.1',
    MRSpectroscopyStorage: '1.2.840.10008.5.1.4.1.1.4.2',
    EnhancedMRColorImageStorage: '1.2.840.10008.5.1.4.1.1.4.3',
    LegacyConvertedEnhancedMRImageStorage: '1.2.840.10008.5.1.4.1.1.4.4',
    NuclearMedicineImageStorageRetired: '1.2.840.10008.5.1.4.1.1.5', // retired
    UltrasoundImageStorageRetired: '1.2.840.10008.5.1.4.1.1.6', // retired
    UltrasoundImageStorage: '1.2.840.10008.5.1.4.1.1.6.1',
    EnhancedUSVolumeStorage: '1.2.840.10008.5.1.4.1.1.6.2',
    SecondaryCaptureImageStorage: '1.2.840.10008.5.1.4.1.1.7',
    MultiframeSingleBitSecondaryCaptureImageStorage: '1.2.840.10008.5.1.4.1.1.7.1',
    MultiframeGrayscaleByteSecondaryCaptureImageStorage: '1.2.840.10008.5.1.4.1.1.7.2',
    MultiframeGrayscaleWordSecondaryCaptureImageStorage: '1.2.840.10008.5.1.4.1.1.7.3',
    MultiframeTrueColorSecondaryCaptureImageStorage: '1.2.840.10008.5.1.4.1.1.7.4',
    StandaloneOverlayStorageRetired: '1.2.840.10008.5.1.4.1.1.8', // retired
    StandaloneCurveStorageRetired: '1.2.840.10008.5.1.4.1.1.9', // retired
    WaveformStorageTrialRetired: '1.2.840.10008.5.1.4.1.1.9.1', // retired
    TwelveleadECGWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.1.1',
    GeneralECGWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.1.2',
    AmbulatoryECGWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.1.3',
    HemodynamicWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.2.1',
    CardiacElectrophysiologyWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.3.1',
    BasicVoiceAudioWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.4.1',
    GeneralAudioWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.4.2',
    ArterialPulseWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.5.1',
    RespiratoryWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.6.1',
    StandaloneModalityLUTStorageRetired: '1.2.840.10008.5.1.4.1.1.10', // retired
    StandaloneVOILUTStorageRetired: '1.2.840.10008.5.1.4.1.1.11', // retired
    GrayscaleSoftcopyPresentationStateStorage: '1.2.840.10008.5.1.4.1.1.11.1',
    ColorSoftcopyPresentationStateStorage: '1.2.840.10008.5.1.4.1.1.11.2',
    PseudoColorSoftcopyPresentationStateStorage: '1.2.840.10008.5.1.4.1.1.11.3',
    BlendingSoftcopyPresentationStateStorage: '1.2.840.10008.5.1.4.1.1.11.4',
    XAXRFGrayscaleSoftcopyPresentationStateStorage: '1.2.840.10008.5.1.4.1.1.11.5',
    GrayscalePlanarMPRVolumetricPresentationStateStorage: '1.2.840.10008.5.1.4.1.1.11.6',
    CompositingPlanarMPRVolumetricPresentationStateStorage: '1.2.840.10008.5.1.4.1.1.11.7',
    AdvancedBlendingPresentationStateStorage: '1.2.840.10008.5.1.4.1.1.11.8',
    VolumeRenderingVolumetricPresentationStateStorage: '1.2.840.10008.5.1.4.1.1.11.9',
    SegmentedVolumeRenderingVolumetricPresentationStateStorage: '1.2.840.10008.5.1.4.1.1.11.10',
    MultipleVolumeRenderingVolumetricPresentationStateStorage: '1.2.840.10008.5.1.4.1.1.11.11',
    XRayAngiographicImageStorage: '1.2.840.10008.5.1.4.1.1.12.1',
    EnhancedXAImageStorage: '1.2.840.10008.5.1.4.1.1.12.1.1',
    XRayRadiofluoroscopicImageStorage: '1.2.840.10008.5.1.4.1.1.12.2',
    EnhancedXRFImageStorage: '1.2.840.10008.5.1.4.1.1.12.2.1',
    XRayAngiographicBiPlaneImageStorageRetired: '1.2.840.10008.5.1.4.1.1.12.3', // retired
    XRay3DAngiographicImageStorage: '1.2.840.10008.5.1.4.1.1.13.1.1',
    XRay3DCraniofacialImageStorage: '1.2.840.10008.5.1.4.1.1.13.1.2',
    BreastTomosynthesisImageStorage: '1.2.840.10008.5.1.4.1.1.13.1.3',
    BreastProjectionXRayImageStorageForPresentation: '1.2.840.10008.5.1.4.1.1.13.1.4',
    BreastProjectionXRayImageStorageForProcessing: '1.2.840.10008.5.1.4.1.1.13.1.5',
    IntravascularOpticalCoherenceTomographyImageStorageForPresentation: '1.2.840.10008.5.1.4.1.1.14.1',
    IntravascularOpticalCoherenceTomographyImageStorageForProcessing: '1.2.840.10008.5.1.4.1.1.14.2',
    NuclearMedicineImageStorage: '1.2.840.10008.5.1.4.1.1.20',
    ParametricMapStorage: '1.2.840.10008.5.1.4.1.1.30',
    RawDataStorage: '1.2.840.10008.5.1.4.1.1.66',
    SpatialRegistrationStorage: '1.2.840.10008.5.1.4.1.1.66.1',
    SpatialFiducialsStorage: '1.2.840.10008.5.1.4.1.1.66.2',
    DeformableSpatialRegistrationStorage: '1.2.840.10008.5.1.4.1.1.66.3',
    SegmentationStorage: '1.2.840.10008.5.1.4.1.1.66.4',
    SurfaceSegmentationStorage: '1.2.840.10008.5.1.4.1.1.66.5',
    TractographyResultsStorage: '1.2.840.10008.5.1.4.1.1.66.6',
    RealWorldValueMappingStorage: '1.2.840.10008.5.1.4.1.1.67',
    SurfaceScanMeshStorage: '1.2.840.10008.5.1.4.1.1.68.1',
    SurfaceScanPointCloudStorage: '1.2.840.10008.5.1.4.1.1.68.2',
    VLImageStorageTrialRetired: '1.2.840.10008.5.1.4.1.1.77.1', // retired
    VLMultiframeImageStorageTrialRetired: '1.2.840.10008.5.1.4.1.1.77.2', // retired
    VLEndoscopicImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.1',
    VideoEndoscopicImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.1.1',
    VLMicroscopicImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.2',
    VideoMicroscopicImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.2.1',
    VLSlideCoordinatesMicroscopicImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.3',
    VLPhotographicImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.4',
    VideoPhotographicImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.4.1',
    OphthalmicPhotography8BitImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.5.1',
    OphthalmicPhotography16BitImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.5.2',
    StereometricRelationshipStorage: '1.2.840.10008.5.1.4.1.1.77.1.5.3',
    OphthalmicTomographyImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.5.4',
    WideFieldOphthalmicPhotographyStereographicProjectionImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.5.5',
    WideFieldOphthalmicPhotography3DCoordinatesImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.5.6',
    OphthalmicOpticalCoherenceTomographyEnFaceImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.5.7',
    OphthalmicOpticalCoherenceTomographyBscanVolumeAnalysisStorage: '1.2.840.10008.5.1.4.1.1.77.1.5.8',
    VLWholeSlideMicroscopyImageStorage: '1.2.840.10008.5.1.4.1.1.77.1.6',
    LensometryMeasurementsStorage: '1.2.840.10008.5.1.4.1.1.78.1',
    AutorefractionMeasurementsStorage: '1.2.840.10008.5.1.4.1.1.78.2',
    KeratometryMeasurementsStorage: '1.2.840.10008.5.1.4.1.1.78.3',
    SubjectiveRefractionMeasurementsStorage: '1.2.840.10008.5.1.4.1.1.78.4',
    VisualAcuityMeasurementsStorage: '1.2.840.10008.5.1.4.1.1.78.5',
    SpectaclePrescriptionReportStorage: '1.2.840.10008.5.1.4.1.1.78.6',
    OphthalmicAxialMeasurementsStorage: '1.2.840.10008.5.1.4.1.1.78.7',
    IntraocularLensCalculationsStorage: '1.2.840.10008.5.1.4.1.1.78.8',
    MacularGridThicknessandVolumeReportStorage: '1.2.840.10008.5.1.4.1.1.79.1',
    OphthalmicVisualFieldStaticPerimetryMeasurementsStorage: '1.2.840.10008.5.1.4.1.1.80.1',
    OphthalmicThicknessMapStorage: '1.2.840.10008.5.1.4.1.1.81.1',
    CornealTopographyMapStorage: '1.2.840.10008.5.1.4.1.1.82.1',
    TextSRStorageTrialRetired: '1.2.840.10008.5.1.4.1.1.88.1', // retired
    AudioSRStorageTrialRetired: '1.2.840.10008.5.1.4.1.1.88.2', // retired
    DetailSRStorageTrialRetired: '1.2.840.10008.5.1.4.1.1.88.3', // retired
    ComprehensiveSRStorageTrialRetired: '1.2.840.10008.5.1.4.1.1.88.4', // retired
    BasicTextSRStorage: '1.2.840.10008.5.1.4.1.1.88.11',
    EnhancedSRStorage: '1.2.840.10008.5.1.4.1.1.88.22',
    ComprehensiveSRStorage: '1.2.840.10008.5.1.4.1.1.88.33',
    Comprehensive3DSRStorage: '1.2.840.10008.5.1.4.1.1.88.34',
    ExtensibleSRStorage: '1.2.840.10008.5.1.4.1.1.88.35',
    ProcedureLogStorage: '1.2.840.10008.5.1.4.1.1.88.40',
    MammographyCADSRStorage: '1.2.840.10008.5.1.4.1.1.88.50',
    KeyObjectSelectionDocumentStorage: '1.2.840.10008.5.1.4.1.1.88.59',
    ChestCADSRStorage: '1.2.840.10008.5.1.4.1.1.88.65',
    XRayRadiationDoseSRStorage: '1.2.840.10008.5.1.4.1.1.88.67',
    RadiopharmaceuticalRadiationDoseSRStorage: '1.2.840.10008.5.1.4.1.1.88.68',
    ColonCADSRStorage: '1.2.840.10008.5.1.4.1.1.88.69',
    ImplantationPlanSRStorage: '1.2.840.10008.5.1.4.1.1.88.70',
    AcquisitionContextSRStorage: '1.2.840.10008.5.1.4.1.1.88.71',
    SimplifiedAdultEchoSRStorage: '1.2.840.10008.5.1.4.1.1.88.72',
    PatientRadiationDoseSRStorage: '1.2.840.10008.5.1.4.1.1.88.73',
    ContentAssessmentResultsStorage: '1.2.840.10008.5.1.4.1.1.90.1',
    EncapsulatedPDFStorage: '1.2.840.10008.5.1.4.1.1.104.1',
    EncapsulatedCDAStorage: '1.2.840.10008.5.1.4.1.1.104.2',
    PositronEmissionTomographyImageStorage: '1.2.840.10008.5.1.4.1.1.128',
    LegacyConvertedEnhancedPETImageStorage: '1.2.840.10008.5.1.4.1.1.128.1',
    StandalonePETCurveStorageRetired: '1.2.840.10008.5.1.4.1.1.129', // retired
    EnhancedPETImageStorage: '1.2.840.10008.5.1.4.1.1.130',
    BasicStructuredDisplayStorage: '1.2.840.10008.5.1.4.1.1.131',
    CTDefinedProcedureProtocolStorage: '1.2.840.10008.5.1.4.1.1.200.1',
    CTPerformedProcedureProtocolStorage: '1.2.840.10008.5.1.4.1.1.200.2',
    ProtocolApprovalStorage: '1.2.840.10008.5.1.4.1.1.200.3',
    ProtocolApprovalInformationModelFIND: '1.2.840.10008.5.1.4.1.1.200.4',
    ProtocolApprovalInformationModelMOVE: '1.2.840.10008.5.1.4.1.1.200.5',
    ProtocolApprovalInformationModelGET: '1.2.840.10008.5.1.4.1.1.200.6',
    RTImageStorage: '1.2.840.10008.5.1.4.1.1.481.1',
    RTDoseStorage: '1.2.840.10008.5.1.4.1.1.481.2',
    RTStructureSetStorage: '1.2.840.10008.5.1.4.1.1.481.3',
    RTBeamsTreatmentRecordStorage: '1.2.840.10008.5.1.4.1.1.481.4',
    RTPlanStorage: '1.2.840.10008.5.1.4.1.1.481.5',
    RTBrachyTreatmentRecordStorage: '1.2.840.10008.5.1.4.1.1.481.6',
    RTTreatmentSummaryRecordStorage: '1.2.840.10008.5.1.4.1.1.481.7',
    RTIonPlanStorage: '1.2.840.10008.5.1.4.1.1.481.8',
    RTIonBeamsTreatmentRecordStorage: '1.2.840.10008.5.1.4.1.1.481.9',
    DICOSCTImageStorage: '1.2.840.10008.5.1.4.1.1.501.1',
    DICOSDigitalXRayImageStorageForPresentation: '1.2.840.10008.5.1.4.1.1.501.2.1',
    DICOSDigitalXRayImageStorageForProcessing: '1.2.840.10008.5.1.4.1.1.501.2.2',
    DICOSThreatDetectionReportStorage: '1.2.840.10008.5.1.4.1.1.501.3',
    DICOS2DAITStorage: '1.2.840.10008.5.1.4.1.1.501.4',
    DICOS3DAITStorage: '1.2.840.10008.5.1.4.1.1.501.5',
    DICOSQuadrupoleResonanceQRStorage: '1.2.840.10008.5.1.4.1.1.501.6',
    EddyCurrentImageStorage: '1.2.840.10008.5.1.4.1.1.601.1',
    EddyCurrentMultiframeImageStorage: '1.2.840.10008.5.1.4.1.1.601.2',
    PatientRootQueryRetrieveInformationModelFIND: '1.2.840.10008.5.1.4.1.2.1.1',
    PatientRootQueryRetrieveInformationModelMOVE: '1.2.840.10008.5.1.4.1.2.1.2',
    PatientRootQueryRetrieveInformationModelGET: '1.2.840.10008.5.1.4.1.2.1.3',
    StudyRootQueryRetrieveInformationModelFIND: '1.2.840.10008.5.1.4.1.2.2.1',
    StudyRootQueryRetrieveInformationModelMOVE: '1.2.840.10008.5.1.4.1.2.2.2',
    StudyRootQueryRetrieveInformationModelGET: '1.2.840.10008.5.1.4.1.2.2.3',
    PatientStudyOnlyQueryRetrieveInformationModelFINDRetired: '1.2.840.10008.5.1.4.1.2.3.1', // retired
    PatientStudyOnlyQueryRetrieveInformationModelMOVERetired: '1.2.840.10008.5.1.4.1.2.3.2', // retired
    PatientStudyOnlyQueryRetrieveInformationModelGETRetired: '1.2.840.10008.5.1.4.1.2.3.3', // retired
    CompositeInstanceRootRetrieveMOVE: '1.2.840.10008.5.1.4.1.2.4.2',
    CompositeInstanceRootRetrieveGET: '1.2.840.10008.5.1.4.1.2.4.3',
    CompositeInstanceRetrieveWithoutBulkDataGET: '1.2.840.10008.5.1.4.1.2.5.3',
    DefinedProcedureProtocolInformationModelFIND: '1.2.840.10008.5.1.4.20.1',
    DefinedProcedureProtocolInformationModelMOVE: '1.2.840.10008.5.1.4.20.2',
    DefinedProcedureProtocolInformationModelGET: '1.2.840.10008.5.1.4.20.3',
    ModalityWorklistInformationModelFIND: '1.2.840.10008.5.1.4.31',
    GeneralPurposeWorklistManagementMetaSOPClassRetired: '1.2.840.10008.5.1.4.32', // retired
    GeneralPurposeWorklistInformationModelFINDRetired: '1.2.840.10008.5.1.4.32.1', // retired
    GeneralPurposeScheduledProcedureStepSOPClassRetired: '1.2.840.10008.5.1.4.32.2', // retired
    GeneralPurposePerformedProcedureStepSOPClassRetired: '1.2.840.10008.5.1.4.32.3', // retired
    InstanceAvailabilityNotificationSOPClass: '1.2.840.10008.5.1.4.33',
    RTBeamsDeliveryInstructionStorageTrialRetired: '1.2.840.10008.5.1.4.34.1', // retired
    RTConventionalMachineVerificationTrialRetired: '1.2.840.10008.5.1.4.34.2', // retired
    RTIonMachineVerificationTrialRetired: '1.2.840.10008.5.1.4.34.3', // retired
    UnifiedWorklistandProcedureStepServiceClassTrialRetired: '1.2.840.10008.5.1.4.34.4', // retired
    UnifiedProcedureStepPushSOPClassTrialRetired: '1.2.840.10008.5.1.4.34.4.1', // retired
    UnifiedProcedureStepWatchSOPClassTrialRetired: '1.2.840.10008.5.1.4.34.4.2', // retired
    UnifiedProcedureStepPullSOPClassTrialRetired: '1.2.840.10008.5.1.4.34.4.3', // retired
    UnifiedProcedureStepEventSOPClassTrialRetired: '1.2.840.10008.5.1.4.34.4.4', // retired
    UPSGlobalSubscriptionSOPInstance: '1.2.840.10008.5.1.4.34.5',
    UPSFilteredGlobalSubscriptionSOPInstance: '1.2.840.10008.5.1.4.34.5.1',
    UnifiedWorklistandProcedureStepServiceClass: '1.2.840.10008.5.1.4.34.6',
    UnifiedProcedureStepPushSOPClass: '1.2.840.10008.5.1.4.34.6.1',
    UnifiedProcedureStepWatchSOPClass: '1.2.840.10008.5.1.4.34.6.2',
    UnifiedProcedureStepPullSOPClass: '1.2.840.10008.5.1.4.34.6.3',
    UnifiedProcedureStepEventSOPClass: '1.2.840.10008.5.1.4.34.6.4',
    RTBeamsDeliveryInstructionStorage: '1.2.840.10008.5.1.4.34.7',
    RTConventionalMachineVerification: '1.2.840.10008.5.1.4.34.8',
    RTIonMachineVerification: '1.2.840.10008.5.1.4.34.9',
    RTBrachyApplicationSetupDeliveryInstructionStorage: '1.2.840.10008.5.1.4.34.10',
    GeneralRelevantPatientInformationQuery: '1.2.840.10008.5.1.4.37.1',
    BreastImagingRelevantPatientInformationQuery: '1.2.840.10008.5.1.4.37.2',
    CardiacRelevantPatientInformationQuery: '1.2.840.10008.5.1.4.37.3',
    HangingProtocolStorage: '1.2.840.10008.5.1.4.38.1',
    HangingProtocolInformationModelFIND: '1.2.840.10008.5.1.4.38.2',
    HangingProtocolInformationModelMOVE: '1.2.840.10008.5.1.4.38.3',
    HangingProtocolInformationModelGET: '1.2.840.10008.5.1.4.38.4',
    ColorPaletteStorage: '1.2.840.10008.5.1.4.39.1',
    ColorPaletteQueryRetrieveInformationModelFIND: '1.2.840.10008.5.1.4.39.2',
    ColorPaletteQueryRetrieveInformationModelMOVE: '1.2.840.10008.5.1.4.39.3',
    ColorPaletteQueryRetrieveInformationModelGET: '1.2.840.10008.5.1.4.39.4',
    ProductCharacteristicsQuerySOPClass: '1.2.840.10008.5.1.4.41',
    SubstanceApprovalQuerySOPClass: '1.2.840.10008.5.1.4.42',
    GenericImplantTemplateStorage: '1.2.840.10008.5.1.4.43.1',
    GenericImplantTemplateInformationModelFIND: '1.2.840.10008.5.1.4.43.2',
    GenericImplantTemplateInformationModelMOVE: '1.2.840.10008.5.1.4.43.3',
    GenericImplantTemplateInformationModelGET: '1.2.840.10008.5.1.4.43.4',
    ImplantAssemblyTemplateStorage: '1.2.840.10008.5.1.4.44.1',
    ImplantAssemblyTemplateInformationModelFIND: '1.2.840.10008.5.1.4.44.2',
    ImplantAssemblyTemplateInformationModelMOVE: '1.2.840.10008.5.1.4.44.3',
    ImplantAssemblyTemplateInformationModelGET: '1.2.840.10008.5.1.4.44.4',
    ImplantTemplateGroupStorage: '1.2.840.10008.5.1.4.45.1',
    ImplantTemplateGroupInformationModelFIND: '1.2.840.10008.5.1.4.45.2',
    ImplantTemplateGroupInformationModelMOVE: '1.2.840.10008.5.1.4.45.3',
    ImplantTemplateGroupInformationModelGET: '1.2.840.10008.5.1.4.45.4',
    NativeDICOMModel: '1.2.840.10008.7.1.1',
    AbstractMultiDimensionalImageModel: '1.2.840.10008.7.1.2',
    DICOMContentMappingResource: '1.2.840.10008.8.1.1',
    dicomDeviceName: '1.2.840.10008.15.0.3.1',
    dicomDescription: '1.2.840.10008.15.0.3.2',
    dicomManufacturer: '1.2.840.10008.15.0.3.3',
    dicomManufacturerModelName: '1.2.840.10008.15.0.3.4',
    dicomSoftwareVersion: '1.2.840.10008.15.0.3.5',
    dicomVendorData: '1.2.840.10008.15.0.3.6',
    dicomAETitle: '1.2.840.10008.15.0.3.7',
    dicomNetworkConnectionReference: '1.2.840.10008.15.0.3.8',
    dicomApplicationCluster: '1.2.840.10008.15.0.3.9',
    dicomAssociationInitiator: '1.2.840.10008.15.0.3.10',
    dicomAssociationAcceptor: '1.2.840.10008.15.0.3.11',
    dicomHostname: '1.2.840.10008.15.0.3.12',
    dicomPort: '1.2.840.10008.15.0.3.13',
    dicomSOPClass: '1.2.840.10008.15.0.3.14',
    dicomTransferRole: '1.2.840.10008.15.0.3.15',
    dicomTransferSyntax: '1.2.840.10008.15.0.3.16',
    dicomPrimaryDeviceType: '1.2.840.10008.15.0.3.17',
    dicomRelatedDeviceReference: '1.2.840.10008.15.0.3.18',
    dicomPreferredCalledAETitle: '1.2.840.10008.15.0.3.19',
    dicomTLSCyphersuite: '1.2.840.10008.15.0.3.20',
    dicomAuthorizedNodeCertificateReference: '1.2.840.10008.15.0.3.21',
    dicomThisNodeCertificateReference: '1.2.840.10008.15.0.3.22',
    dicomInstalled: '1.2.840.10008.15.0.3.23',
    dicomStationName: '1.2.840.10008.15.0.3.24',
    dicomDeviceSerialNumber: '1.2.840.10008.15.0.3.25',
    dicomInstitutionName: '1.2.840.10008.15.0.3.26',
    dicomInstitutionAddress: '1.2.840.10008.15.0.3.27',
    dicomInstitutionDepartmentName: '1.2.840.10008.15.0.3.28',
    dicomIssuerOfPatientID: '1.2.840.10008.15.0.3.29',
    dicomPreferredCallingAETitle: '1.2.840.10008.15.0.3.30',
    dicomSupportedCharacterSet: '1.2.840.10008.15.0.3.31',
    dicomConfigurationRoot: '1.2.840.10008.15.0.4.1',
    dicomDevicesRoot: '1.2.840.10008.15.0.4.2',
    dicomUniqueAETitlesRegistryRoot: '1.2.840.10008.15.0.4.3',
    dicomDevice: '1.2.840.10008.15.0.4.4',
    dicomNetworkAE: '1.2.840.10008.15.0.4.5',
    dicomNetworkConnection: '1.2.840.10008.15.0.4.6',
    dicomUniqueAETitle: '1.2.840.10008.15.0.4.7',
    dicomTransferCapability: '1.2.840.10008.15.0.4.8',
    UniversalCoordinatedTime: '1.2.840.10008.15.1.1',
};
